import React, { useEffect, useRef, useState } from 'react';
import "./award.css";
import { 
    tool,
    leaf_b,
    award1,
    award2,
    award3,
    award4,
    leaf1,
} from "../../assets/images/images.js";

function Award() {
    const carouselRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedAward, setSelectedAward] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const awards = [
        {
            id: 1,
            image: award1,
            date: "March 10, 2024",
            title: "Best Orthodontic Practice",
            description: "Honored for contributions to community dental health awareness and education programs",
        },
        {
            id: 2,
            image: award2,
            date: "March 10, 2024",
            title: "Best Orthodontic Practice",
            description: "Honored for contributions to community dental health awareness and education programs",
        },
        {
            id: 3,
            image: award3,
            date: "March 10, 2024",
            title: "Best Orthodontic Practice",
            description: "Honored for contributions to community dental health awareness and education programs",
        },
        {
            id: 4,
            image: award4,
            date: "March 10, 2024",
            title: "Best Orthodontic Practice",
            description: "Honored for contributions to community dental health awareness and education programs",
        }
    ];

    // Calculate total pages (4 cards per page)
    const totalPages = Math.ceil(awards.length / 4);
    
    // Get current page awards
    const getCurrentPageAwards = () => {
        const startIndex = currentPage * 4;
        return awards.slice(startIndex, startIndex + 4);
    };

    // Auto-scroll functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
        }, 4000); // Change page every 4 seconds

        return () => clearInterval(interval);
    }, [totalPages]);

    const goToPage = (pageIndex) => {
        setCurrentPage(pageIndex);
    };

    const goToNextPage = () => {
        setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
    };

    const goToPrevPage = () => {
        setCurrentPage((prevPage) => (prevPage - 1 + totalPages) % totalPages);
    };

    const handleSeeMore = (award) => {
        setSelectedAward(award);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedAward(null);
    };

    return (
        <>
            <section className="container margin-auto award-section">
                <img src={leaf_b} alt='leaf' className="corner-image left-corner"/>
                <img src={tool} alt='tool' className="corner-image right-corner"/>
                
                <h3 className='awards-title'>AWARDS & RECOGNITIONS</h3>
                
                <div className="awards-carousel-container">
                    

                    {/* Carousel */}
                    <div className="awards-carousel" ref={carouselRef}>
                        {getCurrentPageAwards().map((award) => (
                            <div key={award.id} className="award-card">
                                <div className="award-image">
                                    <img src={award.image} alt={`Award ${award.id}`} />
                                </div>
                                
                                <div className="award-content">
                                    <div className="award-date">{award.date}</div>
                                    <h4 className="award-title">{award.title}</h4>
                                    <div className="content-with-leaf-overlay">
                                        <p className="award-description">{award.description}</p>
                                        <img 
                                            src={leaf1} 
                                            alt="laurel leaf" 
                                            className="leaf-background"
                                            onLoad={() => console.log('Leaf image loaded successfully')}
                                            onError={(e) => console.error('Leaf image failed to load:', e)}
                                        />
                                    </div>
                                    <button 
                                        className="see-details-btn"
                                        onClick={() => handleSeeMore(award)}
                                    >
                                        See Details
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    {/* Navigation dots */}
                    <div className="carousel-dots">
                        {Array.from({ length: totalPages }, (_, index) => (
                            <span 
                                key={index} 
                                className={`dot ${index === currentPage ? 'active' : ''}`}
                                onClick={() => goToPage(index)}
                            ></span>
                        ))}
                    </div>
                </div>
            </section>

            {/* Award Detail Modal */}
            {showModal && selectedAward && (
                <div className="award-modal-overlay" onClick={closeModal}>
                    <div className="award-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close-btn" onClick={closeModal}>
                            <span className="sr-only">Close</span>
                        </button>
                        
                        <div className="modal-content">
                            <div className="modal-image-section">
                                <div className="modal-image-container">
                                    <img 
                                        src={selectedAward.image} 
                                        alt={`Award ${selectedAward.id}`} 
                                        className="modal-award-image"
                                    />
                                </div>
                            </div>

                            <div className="modal-info-section">
                                <div className="modal-award-date">
                                    <i className="fa fa-calendar"></i>
                                    <span>{selectedAward.date}</span>
                                </div>

                                <h2 className="modal-award-title">{selectedAward.title}</h2>
                                
                                <div className="modal-award-description">
                                    <p>{selectedAward.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Award;